import $ from 'jquery'
import initCollapsible from './modules/collapsible';
import changeCollapsible from './modules/collapsible';
import initImageGallery from './modules/image_gallery';

function initModules() {
        initCollapsible()
        initImageGallery()

        
}


export default initModules


